import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=7feb80d5&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports